export default "__VITE_ASSET__BeNA$uFd__"